import {IProjetModel} from "../../Model/Projet/ProjetModel.js";
import {ResponseApi} from "../../Model/ResponseApi.js";
import {OnProjetAdd, OnProjetUpdate} from "../../Delegates/ProjetDelegate.js";
import {String} from "../../Tools/Misc.js"
import {JsonFetchJson} from "../../Helper/FetchHelper.js";
import {NotificationHelper} from "../../Helper/NotificationHelper.js";

export class ProjetUpsert {
        public static Upsert = async (payload: IProjetModel) => {
            return JsonFetchJson.Put<ResponseApi<IProjetModel>>("/projet", payload)
                .then((response: ResponseApi<IProjetModel>) => {

                    if (response.Status != 200)
                    {
                        response.Errors.forEach(x => NotificationHelper.Instance.error(x.Message));
                        return;
                    }
                    
                    NotificationHelper.Instance.success("Le client a été enregistré.");
                    if (payload.Primarykey == String.GetEmptyGuid) {
                        OnProjetAdd.Fire(response.Data);
                    } else {
                        OnProjetUpdate.Fire(response.Data);
                    }
                    return response.Data;
                });
        }
    }
